<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/8/2020
  -->

<template>

	<FormElementTemplate
		class="form-element-title-view-root"
		:formElement="formElement"
		:viewMode="viewMode"
		:menuHideRequired="true"
		:hideAsterisk="true"
		v-bind="$attrs"
		>
	</FormElementTemplate>

</template>

<script>

import BaseFormElement from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTitle from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementTitle";
import FormElementTemplate from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTemplate.vue";

export default {
	name: "FormElementTitleView",
	components: {FormElementTemplate},
	extends: BaseFormElement,
	props: {
		formElement: FormElementTitle,
		title: String
	},

	data() {
		return {}
	},

}
</script>

<style lang="scss">

.form-element-title-view-root {
	.form-title {
		font-size: 32px;
		input, textarea {
			font-size: 32px;
			line-height: 42px;
		}

	}

}

</style>
